import styles from './A_SelectItemList.module.css';
import cn from 'classnames';

interface A_SelectItemListProps {
  text: string;
  size: 'thin' | 'wide';
  onClick: () => void;
  isActive?: boolean;
}

export default function A_SelectItemList({
  text,
  size,
  onClick,
  isActive,
}: A_SelectItemListProps) {
  return (
    <button
      className={cn(styles.wrapper, styles[size], 'text-p-4', {
        [styles.active]: isActive,
      })}
      onClick={onClick}
    >
      <span className={styles.label}>{text}</span>
    </button>
  );
}
